<template>
    <van-form  @submit="onSubmit">
        <van-field
                label="抵押物地址是否一致:"
                label-width="100px"
                input-align="left"
                name="address"
                readonly
                :rules="[{ required: true, message: '请选择' }]"
        >
            <template #input>
                <van-radio-group v-model="formData.address" direction="horizontal">
                    <van-radio name="是">是</van-radio>
                    <van-radio name="否">否</van-radio>
                </van-radio-group>
            </template>
        </van-field>

        <van-field
                label="成员人数:"
                label-width="100px"
                input-align="left"
                name="member"
                readonly
                :rules="[{ required: true, message: '请选择' }]"
        >
            <template #input>
                <van-stepper v-model="formData.member" min="2" step="1"/>
            </template>
        </van-field>

        <van-field
                readonly
                clickable
                name="maritalStatus"
                :value="formData.maritalStatus"
                label="婚姻状况:"
                placeholder="点击选择"
                label-width="100px"
                input-align="left"
                @click="showPicker = true"
                :rules="[{ required: true, message: '请选择婚姻状况' }]"
        />
        <van-popup v-model="showPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="maritals"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"
            />
        </van-popup>

        <van-field
                label="从事行业、经营、收入情况等:"
                placeholder="请输入从事行业、经营、收入情况等"
                label-width="100px"
                input-align="left"
                name="other"
                v-model="formData.other"
                :rules="[{ required: true, message: '请输入从事行业、经营、收入情况等' }]"
        />

        <van-field
                label="当前逾期情况:"
                label-width="100px"
                input-align="left"
                name="overdue"
                readonly
                :rules="[{ required: true, message: '请选择有无当前逾期' }]"
        >
            <template #input>
                <van-radio-group v-model="formData.overdue" direction="horizontal" @change="onOverdueChange">
                    <van-radio name="有">有</van-radio>
                    <van-radio name="无">无</van-radio>
                </van-radio-group>
            </template>
        </van-field>

        <van-field v-if="overdueShow"
                label="逾期原因:"
                placeholder="请输入逾期原因"
                label-width="100px"
                input-align="left"
                name="overdueReason"
                v-model="formData.overdueReason"
                :rules="[{ required: true, message: '请输入逾期原因' }]"
        />

        <van-field
                label="客户是否有担保信息:"
                label-width="100px"
                input-align="left"
                name="guarantee"
                readonly
                :rules="[{ required: true, message: '请选择客户是否有担保信息' }]"
        >
            <template #input>
                <van-radio-group v-model="formData.guarantee" direction="horizontal">
                    <van-radio name="有">有</van-radio>
                    <van-radio name="无">无</van-radio>
                </van-radio-group>
            </template>
        </van-field>

        <van-field
                   label="资金用途、转贷目的:"
                   placeholder="请输入资金用途、转贷目的"
                   label-width="100px"
                   input-align="left"
                   name="use"
                   v-model="formData.use"
                   :rules="[{ required: true, message: '请输入资金用途、转贷目的' }]"
        />

        <van-field
                   label="异常与风险提示:"
                   placeholder="请输入异常与风险提示"
                   label-width="100px"
                   input-align="left"
                   name="risks"
                   v-model="formData.risks"
                   :rules="[{ required: true, message: '请输入异常与风险提示' }]"
        />


        <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit" :loading="loading">
                保存
            </van-button>
        </div>
    </van-form>
</template>

<script>
    import Vue from 'vue'
    import { Toast } from 'vant'
    Vue.use(Toast)
    import { debounce,cloneDeep } from 'lodash'
    import {ImagePreview} from 'vant'
    import {getForeClousureFileList} from '@/api/loanInfo'
    import {saveFormData,getFormData} from '@/api/foreclosure'
    import icFile from '@/assets/home/ic_file.png'
    export default {
        name: 'interview_form',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                applyInfo:{},
                showPicker:false,
                maritals:['已婚','未婚','离异','丧偶'],
                overdueShow:false,
                formData:{},
                show:false,
                loading:false,
                list: [
                    {
                        label: '地址是否与抵押物地址一致',
                        ext: 'address',
                        info: '',
                        formModule: 'F_InterviewView'
                    },
                    {
                        label: '成员人数',
                        ext: 'member',
                        info: '',
                        formModule: 'F_InterviewView'
                    },
                    {
                        label: '婚姻状况',
                        ext: 'maritalStatus',
                        info: '',
                        formModule: 'F_InterviewView'
                    },
                    {
                        label: '从事行业、经营、收入情况等',
                        ext: 'other',
                        info: '',
                        formModule: 'F_InterviewView'
                    },
                    {
                        label: '客户是否有当前逾期',
                        ext: 'overdue',
                        info: '',
                        formModule: 'F_InterviewView'
                    },
                    {
                        label: '逾期原因',
                        ext: 'overdueReason',
                        info: '',
                        formModule: 'F_InterviewView'
                    },
                    {
                        label: '客户是否有担保信息',
                        ext: 'guarantee',
                        info: '',
                        formModule: 'F_InterviewView'
                    },
                    {
                        label: '资金用途、转贷目的',
                        ext: 'use',
                        info: '',
                        formModule: 'F_InterviewView'
                    },
                    {
                        label: '异常与风险提示',
                        ext: 'risks',
                        info: '',
                        formModule: 'F_InterviewView'
                    }
                ]


            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            loadData() {
                const self = this
                let params = {
                    applyId: this.applyId,
                    formModule: 'F_InterviewView'
                }
                getFormData(params).then(res => {
                    let data={}
                    if (res.success) {
                        res.data!=null&&res.data.forEach((item,index)=>{
                            data[item.ext]=item.info
                        })
                        debounce(() => {
                            self.formData=data
                        },200)()
                    }
                })
            },
            onOverdueChange(value){
                this.overdueShow=(value=='有')
            },
            //报价方案选择
            onConfirm(value){
                this.formData.maritalStatus = value;
                this.showPicker = false;
            },
            onSubmit(values){
                let params=cloneDeep(values)
                this.handleParams(params)
                let data={}
                data.applyId = this.applyId
                data.list = this.list
                data.formModule='F_InterviewView'
                this.loading=true
                saveFormData(data).then(res=>{
                    if(res.success){
                        Toast.success(res.msg);
                    }else{
                        Toast.fail(res.msg);
                    }
                    this.loading=false
                })
            },
            handleParams(params) {
                this.list.forEach((item,index)=>{
                    item.info=params[item.ext]
                })
            }
        }
    }
</script>

<style scoped>

</style>
